import { createRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'
import { Center, Spinner } from '@chakra-ui/react'
import { authenticatedRoute } from './_authenticated'

const Notifications = lazy(() => import('@/pages/notifications').then(m => ({ default: m.Notifications })))

function NotificationsWrapper() {
  return (
    <Suspense fallback={<Center h="100vh"><Spinner size="lg" color="purple.500" /></Center>}>
      <Notifications />
    </Suspense>
  )
}

export const notificationsRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: '/notifications',
  component: NotificationsWrapper,
})
